define('app/models/SegmentCollection',['require','glu/collection','app/models/Segment','config'],function(require) {
	'use strict';

	var Collection = require('glu/collection'),
		Segment = require('app/models/Segment'),
		config = require('config');

	return Collection.extend({
		url: config.apiRoot + 'service/segments',
		model: Segment
	});

});

